module.exports = __webpack_public_path__ + "static/media/sample_doc.9d2e1fd5.zip";